<template>
  <div
    class="m-dropdown-content m-dropdown-content-right m-the-header-sub-menu-dropdown-academies"
    id="MoleculeTheHeaderSubMenuDropDownAcademies"
  >
    <header class="m-dropdown-header-academies">
      <i
        class="fas fa-arrow-left font-size-small margin-right-small m-dropdown-back-icon text-color-vidroop-primary"
        @click.stop="$dropDown.switchDropDown('MoleculeTheHeaderSubMenuDropDownUser')"
      >
      </i>
      <div class="m-dropdown-header-academies-user">
        <span class="ellipsis m-dropdown-title text-color-vidroop-primary">
          {{ nombre }}
        </span>
        <span class="ellipsis m-dropdown-subtitle">
          {{ email }}
        </span>
      </div>
    </header>
    <section class="m-dropdown-section">
      <ul class="m-dropdown-list">
        <li
          v-for="academia in academiasUsuario"
          :key="academia.id"
        >
          <a
            href="#"
            @click.prevent="setAcademy(academia)"
          >
            <span class="m-dropdown-item-icon">
              <i
                :key="`circle${academia.id}`"
                :class="[academia.id === academiaId ? 'fas' : 'far', 'fa-circle font-size-small text-color-academy-primary']"
              >
              </i>
            </span>
            <span
              :title="academia.nombre"
              class="ellipsis m-dropdown-item-text">
              {{ academia.nombre }}
            </span>
          </a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MoleculeTheHeaderSubMenuDropDownAcademies',

  props: {
    academiasUsuario: Array,
    usuario: Object
  },

  computed: {
    academiaId () {
      return this.$store.getters.getAcademyData.id
    },

    email () {
      return this.usuario.email
    },

    nombre () {
      return this.usuario.vidroop_data &&
        this.usuario.vidroop_data.persona &&
        this.usuario.vidroop_data.persona.razon_social
        ? this.usuario.vidroop_data.persona.razon_social
        : this.usuario.email
    }
  },

  watch: {
    academiaId () {
      this.$dropDown.closeDropDown('MoleculeTheHeaderSubMenuDropDownAcademies')
      if (this.academiaId.length && this.$router.currentRoute.name !== 'home') {
        this.$router.push({ name: 'home' })
        this.$alerts.pushAlert('mTheHeaderSubMenuDropDownAcademies', 'setCurrentAcademy', 'success')
      } else if (this.academiaId.length) {
        this.$alerts.pushAlert('mTheHeaderSubMenuDropDownAcademies', 'setCurrentAcademy', 'success')
      }
    }
  },

  methods: {
    setAcademy (academia) {
      this.$store.commit('setAcademyDaysLeft', null)
      this.$auth.setCurrentAcademy(academia)
    }
  }
}
</script>
